'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoScissors = function IoScissors(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 9.1c-1 2.5-9.1 13.4-9.1 13.4l-2.5 2.5s-2.4 1-3.9 3.4-2.6 5.5-2.6 5.5c-0.5 2-2.2 3.6-4.1 3.6-2.4 0-4.4-2.3-4.4-5s2-5 4.4-5c1 0 1.9 0.4 2.6 1 0.2 0.1 0.3 0.3 0.3 0.3l0.2 0.2c0.3 0.3 0.5 0.1 1.1-0.9 0.6-1.1 1.3-2.7 2.1-4.2s3-4.6 3-4.6l1.3-1.8 11.3-15c1.7 1.6 1.4 4 0.3 6.6z m-22.2 25.9c1.1 0 2.2-1.1 2.2-2.5s-1.1-2.5-2.2-2.5-2.2 1.1-2.2 2.5 1 2.5 2.2 2.5z m10.6-12.5c0.7 0 1.3-0.5 1.3-1.2s-0.6-1.3-1.3-1.3-1.2 0.5-1.2 1.3 0.5 1.2 1.2 1.2z m-3.8-1.8c-2.4-3.2-7.1-9.8-7.8-11.6-1.1-2.6-1.4-5 0.4-6.6l10.4 13.9-0.2 0.3-1.3 1.8v0.1c-0.1 0.1-0.8 1-1.5 2.1z m14.4 6.8c2.4 0 4.4 2.3 4.4 5s-2 5-4.4 5c-1.9 0-3.6-1.6-4.2-3.6s-1-3.2-2.5-5.5c-0.9-1.4-2-2.2-2.8-2.8l2.3-2.3h0.1c0.1-0.1 0.1-0.2 0.2-0.3 0.2 0.3 0.4 0.7 0.5 0.9 0.8 1.5 1.6 3.1 2.2 4.2 0.6 1 0.8 1.2 1.1 0.9 0.1-0.1 0-0.1 0.1-0.2h0.1c0-0.1 0.1-0.2 0.3-0.3 0.7-0.6 1.6-1 2.6-1z m0 7.5c1.2 0 2.2-1.1 2.2-2.5s-1-2.5-2.2-2.5-2.2 1.1-2.2 2.5 1.1 2.5 2.2 2.5z' })
        )
    );
};

exports.default = IoScissors;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/scissors.js
// module id = 2406
// module chunks = 0